(function(){
  const questions = $('.js-n-quiz-question').length;
  let correct = 0;

  function scrollToQ(nr, timeout){
    setTimeout(function(){
      const id = $('.js-n-quiz-question[data-nr="'+nr+'"]').parents('.js-n-quiz-card').attr("id");
      $('html, body').animate({
        scrollTop: $("#" + id).offset().top - 100
      }, 750);
    }, timeout);
  }

  $('.js-n-quiz-scrolltop').click(function(e){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#klausimas_1").offset().top - 100
    }, 750);
  });

  $('.js-n-quiz-answer-btn').click(function(e){
    e.preventDefault();
    const next = parseInt($(this).parents('.js-n-quiz-question').data('nr')) + 1;
    if($(this).data('value') == 1){
      $(this).addClass('green').addClass('selected');
      correct++;
    } else {
      $(this).addClass('red').addClass('selected');
      $(this).parents('.js-n-quiz-question').find('.js-n-quiz-answer-btn[data-value="1"]').addClass('green');
    }
    $(this).parents('.js-n-quiz-question').find('.js-n-quiz-answer-btn').prop('disabled', true);
    if(next > questions){
      $('.js-n-quiz-footer').addClass('opened');
      $('.js-n-quiz-correct').text(correct);
      if(correct === questions){
        $('.js-n-quiz-correct').parent().addClass('green');
      } else {
        $('.js-n-quiz-prize').removeAttr('href').removeAttr('download').addClass('disabled');
      }
      setTimeout(function(){
        $('html, body').animate({
          scrollTop: $("#n__quiz__results").offset().top - 100
        }, 750);
      }, 750);
    } else {
      $('.js-n-quiz-question[data-nr="'+ next +'"]').show();
      scrollToQ(next, 750);
    }
  });
})();
// js-n-quiz-footer
// js-n-quiz-question
// js-n-quiz-correct